import { makeAutoObservable, runInAction, toJS } from "mobx";
import { apiLink } from "../helpers/constantVariables";
import { apiDelete, apiGet, apiPostPut } from "../api/api_methods";
import Technical from "../components/recruiter/technical";
import CommonStore from "./common_store";
class LabelStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedTabs = [];
  selectedTabsReset = 0;
    MockTestId = null;
    applicant_id_mock= null;
    ApplicantColor = null;
    label = {};
    labels_list = [{}];
    DeleteLabel = null;
    selectedLabel = null;
    selectedIndex = null;
    selectedLableValues = {};
    resumeSorting = {};
    pdfView = false;
    currentSection = null;
    jobPostData = {};
    individualLabelsIndex = {};
    mockTestData = {};
    applicationData = {};
    loader = false;
    loader2 = false;
    Applicants = false;
    ApplicantLabelArray = []
    section = null;
    ApplicantId = null;
    resumeTableRefresher = 1;
    applicantCardRefresher = 1;
    reportScreenRefresher = null;
    labelFetched = null;
    applicationLabelFetch = false;
    pdfUrl = null;
    setSelectedTabs(value){
      this.selectedTabs = value;
    }
    setSelectedTabsReset(value){
      this.selectedTabsReset = value;
    }
    setApplicationLabelFetch(value){
      this.applicationLabelFetch = value;
    }
    setLabelFetched(value){
      this.labelFetched = value;
    }
    setApplicant_id_mock(value){
      this.applicant_id_mock = value;
    }
    setMockTestId(value){
      this.MockTestId = value;
    }
    setreportScreenRefresher(){
      this.reportScreenRefresher = this.reportScreenRefresher + 1;
    }
    setResumeTableRefresher(value){
      this.resumeTableRefresher = value;
    }
    setsection(value){
      this.section = value;
    }
    setApplicantLabelArray(value){
      this.ApplicantLabelArray = value;
    }
    setApplicantId(value) {
      this.ApplicantId = value;
    }
    setApplicantColor(value) {
      this.ApplicantColor = value;
    }
    setApplicants(value){
      this.Applicants = value;
    }
    setLoader2(value){
      this.loader2 = value;
    }
    setApplicationData(value){
      this.applicationData = value;
    }
    setLoader(value) {
      this.loader = value;
    }
    setMockTestData(value) {
      this.mockTestData = value;
    }
    setindividualLabelsIndex(value) {
      this.individualLabelsIndex = value;
    }
    setJobPostData(value) {
      this.jobPostData = value;
    }
    setCurrentSection(value) {
      this.currentSection = value;
    }
    setPdfView(value){
      this.pdfView = value;
    }
    setPdfUrl(value){
      this.pdfUrl = value;
    }
    setSelctedLabel(value){
      this.selectedLabel = value;
    }
    setLsbel(value){
      this.label = value;
    }
    setSelectedLebelValues(value){
      this.selectedLableValues = value;
    }
    setLabelsList(value){
      this.labels_list = value;
    }
    setSelectedIndex(value){
      this.selectedIndex = value;
    }
    setResumeSorting(value) {
      this.resumeSorting = value;
    }
    setApplicantCardRefresher(value){
      this.applicantCardRefresher(this.applicantCardRefresher + value);
    }
  async PostLabel(body) {
    this.setLoader(true)
    const response = await apiPostPut(body, "/labelInfo/create-label", "POST");
    this.setLoader(false);
    if (response.status === 200) {
      console.log("label created", response?.body?.data);
      // this.labels_list.push(response?.body?.data);
      this.fetchLabelsData();
      // console.log("job post created", JSON.stringify(this.label));
      // this.setLoader(false);
      return true;
    } else {
      alert(response?.body?.message);
      // this.setLoader(false);
      return false;
    }

  }

  async fetchLabelsData() {
      const userId = JSON.parse(localStorage.getItem("user"))?._id;
      // setLoader(true);
      this.setLoader(true);
      try {
        const response = await apiGet(`/labelInfo/get-created-labels/${userId}`);
        if (response.status === 200 && response.body.success) {
          this.setLabelFetched(response.body.data);
          this.setLabelsList(response.body.data);
          // this.labelFetched = value;
        } else {
          console.error(`Error fetching data: ${response.body.message}`);
        }
        this.setLoader(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      } 
    };

  async UpdateLabel(body) {
    const response = await apiPostPut(body, `/labelInfo/update-label/${this.selectedLabel}`, "PUT");
    // this.setLoader(true);
    
    if (response.status === 200) {
      console.log("Label updated", response?.body?.data);
      
      // Directly update the this.labels_list
      const objIndex = this.labels_list.findIndex(item => item._id === this.selectedLabel);
      if (objIndex !== -1) {
        this.labels_list[objIndex].name = body.name;
        this.labels_list[objIndex].color = body.color;
      }
      // this.setLoader(false);
      return true;
    } else {
      alert("Make sure you have filled all the details.");
      // this.setLoader(false);
      return false;
    }
  }
  
  async deleteLabel(id) {
    // this.setLoader(true);
    const response = await apiDelete(`/labelInfo/delete-label/${id}`);
    if (response.status === 200) {
      console.log("label deleted", response?.body?.data);
      this.fetchLabelsData();
      // this.setLoader(false);
      return true;
    } else {
      return console.log("something went wrong");
      // this.setLoader(false);
    }
  }
}

export default LabelStore;
